module.exports = __webpack_public_path__ + "img/pdf.e46a70dd.svg";